import { render, staticRenderFns } from "./SliderComponent.vue?vue&type=template&id=0494d980&scoped=true&"
import script from "./SliderComponent.vue?vue&type=script&lang=js&"
export * from "./SliderComponent.vue?vue&type=script&lang=js&"
import style0 from "./SliderComponent.vue?vue&type=style&index=0&id=0494d980&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0494d980",
  null
  
)

export default component.exports